import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "fw-bolder my-2 mb-8" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Application Details")
const _hoisted_3 = { class: "fs-6 text-gray-400 fw-bold ms-4" }
const _hoisted_4 = {
  class: "col-10 card",
  id: "kt_timeline_widget_2_card"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "card-header position-relative py-0 border-bottom-2" }, [
  /*#__PURE__*/_createElementVNode("ul", {
    class: "nav nav-stretch nav-pills nav-pills-custom d-flex mt-3",
    role: "tablist"
  }, [
    /*#__PURE__*/_createElementVNode("li", {
      class: "nav-item p-0 ms-0 me-8",
      role: "presentation"
    }, [
      /*#__PURE__*/_createElementVNode("a", {
        class: "nav-link btn btn-color-muted active px-0",
        "data-bs-toggle": "pill",
        href: "#kt_timeline_widget_2_tab_1",
        "aria-selected": "true",
        role: "tab"
      }, [
        /*#__PURE__*/_createElementVNode("span", { class: "nav-text fw-semibold fs-7 mb-3" }, " Documents "),
        /*#__PURE__*/_createElementVNode("span", { class: "bullet-custom position-absolute z-index-2 w-100 h-2px top-100 bottom-n100 bg-primary rounded" })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("li", {
      class: "nav-item p-0 ms-0 me-8",
      role: "presentation"
    }, [
      /*#__PURE__*/_createElementVNode("a", {
        class: "nav-link btn btn-color-muted px-0",
        "data-bs-toggle": "pill",
        href: "#kt_timeline_widget_2_tab_2",
        "aria-selected": "false",
        tabindex: "-1",
        role: "tab"
      }, [
        /*#__PURE__*/_createElementVNode("span", { class: "nav-text fw-semibold fs-7 mb-3" }, "Owner Details"),
        /*#__PURE__*/_createElementVNode("span", { class: "bullet-custom position-absolute z-index-2 w-100 h-2px top-100 bottom-n100 bg-primary rounded" })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("li", {
      class: "nav-item p-0 ms-0 me-8",
      role: "presentation"
    }, [
      /*#__PURE__*/_createElementVNode("a", {
        class: "nav-link btn btn-color-muted px-0",
        "data-bs-toggle": "pill",
        href: "#kt_timeline_widget_2_tab_3",
        "aria-selected": "false",
        tabindex: "-1",
        role: "tab"
      }, [
        /*#__PURE__*/_createElementVNode("span", { class: "nav-text fw-semibold fs-7 mb-3" }, "Business Details"),
        /*#__PURE__*/_createElementVNode("span", { class: "bullet-custom position-absolute z-index-2 w-100 h-2px top-100 bottom-n100 bg-primary rounded" })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("li", {
      class: "nav-item p-0 ms-0 me-8",
      role: "presentation"
    }, [
      /*#__PURE__*/_createElementVNode("a", {
        class: "nav-link btn btn-color-muted px-0",
        "data-bs-toggle": "pill",
        href: "#kt_timeline_widget_2_tab_4",
        "aria-selected": "false",
        tabindex: "-1",
        role: "tab"
      }, [
        /*#__PURE__*/_createElementVNode("span", { class: "nav-text fw-semibold fs-7 mb-3" }, "Product Details"),
        /*#__PURE__*/_createElementVNode("span", { class: "bullet-custom position-absolute z-index-2 w-100 h-2px top-100 bottom-n100 bg-primary rounded" })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("li", {
      class: "nav-item p-0 ms-0 me-8",
      role: "presentation"
    }, [
      /*#__PURE__*/_createElementVNode("a", {
        class: "nav-link btn btn-color-muted px-0",
        "data-bs-toggle": "pill",
        href: "#kt_timeline_widget_2_tab_5",
        "aria-selected": "false",
        tabindex: "-1",
        role: "tab"
      }, [
        /*#__PURE__*/_createElementVNode("span", { class: "nav-text fw-semibold fs-7 mb-3" }, "Website Details"),
        /*#__PURE__*/_createElementVNode("span", { class: "bullet-custom position-absolute z-index-2 w-100 h-2px top-100 bottom-n100 bg-primary rounded" })
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "mt-4 p-1" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "btn btn-sm btn-light disabled" }, "Send to Queue")
  ])
], -1)
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = { class: "tab-content" }
const _hoisted_8 = {
  class: "tab-pane fade show active",
  id: "kt_timeline_widget_2_tab_1",
  role: "tabpanel"
}
const _hoisted_9 = { class: "table-responsive" }
const _hoisted_10 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "p-0 w-10px" }),
    /*#__PURE__*/_createElementVNode("th", { class: "p-0 w-25px" }),
    /*#__PURE__*/_createElementVNode("th", { class: "p-0 min-w-400px" }),
    /*#__PURE__*/_createElementVNode("th", { class: "p-0 min-w-50px" }),
    /*#__PURE__*/_createElementVNode("th", { class: "p-0 min-w-50px" })
  ])
], -1)
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", {
  "data-kt-element": "bullet",
  class: "bullet bullet-vertical d-flex align-items-center h-40px bg-success"
}, null, -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { key: 1 }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", {
  "data-kt-element": "bullet",
  class: "bullet bullet-vertical d-flex align-items-center h-40px bg-primary"
}, null, -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "ps-0" }
const _hoisted_19 = {
  href: "#",
  class: "text-gray-800 text-hover-primary fw-bold fs-7"
}
const _hoisted_20 = { class: "text-gray-400 fw-bold fs-7 d-block" }
const _hoisted_21 = {
  key: 2,
  class: "text-end fs-8"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", { class: "mb-n1" }, "status", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", {
  "data-kt-element": "status",
  class: "badge badge-light text-success mt-1"
}, "Approved", -1)
const _hoisted_24 = [
  _hoisted_22,
  _hoisted_23
]
const _hoisted_25 = {
  key: 3,
  class: "text-end fs-8"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("p", { class: "mb-n1" }, "status", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", {
  "data-kt-element": "status",
  class: "badge badge-light text-danger mt-1"
}, "Denied", -1)
const _hoisted_28 = [
  _hoisted_26,
  _hoisted_27
]
const _hoisted_29 = {
  key: 4,
  class: "text-end fs-8"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("p", { class: "mb-n1" }, "status", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", {
  "data-kt-element": "status",
  class: "badge badge-light text-dark mt-1"
}, "In Process", -1)
const _hoisted_32 = [
  _hoisted_30,
  _hoisted_31
]
const _hoisted_33 = {
  key: 5,
  class: "text-start"
}
const _hoisted_34 = { class: "d-flex justify-content-start flex-shrink-0 align-items-center" }
const _hoisted_35 = {
  class: "fs-8 p-2 btn btn-sm btn-outline btn-outline-dashed btn-outline-default w-100",
  "data-bs-toggle": "modal",
  "data-bs-target": "#modal_upload_application_file"
}
const _hoisted_36 = { class: "svg-icon svg-icon-1" }
const _hoisted_37 = {
  key: 6,
  class: "text-start"
}
const _hoisted_38 = { class: "" }
const _hoisted_39 = ["onClick"]
const _hoisted_40 = { class: "svg-icon btn-icon svg-icon-3x" }
const _hoisted_41 = ["onClick"]
const _hoisted_42 = { class: "svg-icon btn-icon svg-icon-3x" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", {
  class: "tab-pane fade",
  id: "kt_timeline_widget_2_tab_2",
  role: "tabpanel"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group input-group-solid mb-5" }, [
    /*#__PURE__*/_createElementVNode("span", {
      class: "input-group-text",
      id: "basic-addon1"
    }, "@"),
    /*#__PURE__*/_createElementVNode("input", {
      type: "text",
      class: "form-control",
      placeholder: "Username",
      "aria-label": "Username",
      "aria-describedby": "basic-addon1"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "input-group input-group-solid mb-5" }, [
    /*#__PURE__*/_createElementVNode("input", {
      type: "text",
      class: "form-control",
      placeholder: "Recipient's username",
      "aria-label": "Recipient's username",
      "aria-describedby": "basic-addon2"
    }),
    /*#__PURE__*/_createElementVNode("span", {
      class: "input-group-text",
      id: "basic-addon2"
    }, "@example.com")
  ]),
  /*#__PURE__*/_createElementVNode("label", {
    for: "basic-url",
    class: "form-label"
  }, "Your vanity URL"),
  /*#__PURE__*/_createElementVNode("div", { class: "input-group input-group-solid mb-5" }, [
    /*#__PURE__*/_createElementVNode("span", {
      class: "input-group-text",
      id: "basic-addon3"
    }, "https://example.com/users/"),
    /*#__PURE__*/_createElementVNode("input", {
      type: "text",
      class: "form-control",
      id: "basic-url",
      "aria-describedby": "basic-addon3"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "input-group input-group-solid mb-5" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, "$"),
    /*#__PURE__*/_createElementVNode("input", {
      type: "text",
      class: "form-control",
      "aria-label": "Amount (to the nearest dollar)"
    }),
    /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, ".00")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "input-group input-group-solid mb-5" }, [
    /*#__PURE__*/_createElementVNode("input", {
      type: "text",
      class: "form-control",
      placeholder: "Username",
      "aria-label": "Username"
    }),
    /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, "@"),
    /*#__PURE__*/_createElementVNode("input", {
      type: "text",
      class: "form-control",
      placeholder: "Server",
      "aria-label": "Server"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "input-group input-group-solid" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, "With textarea"),
    /*#__PURE__*/_createElementVNode("textarea", {
      class: "form-control",
      "aria-label": "With textarea"
    })
  ])
], -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", {
  class: "tab-pane fade",
  id: "kt_timeline_widget_2_tab_3",
  role: "tabpanel"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group input-group-solid mb-5" }, [
    /*#__PURE__*/_createElementVNode("span", {
      class: "input-group-text",
      id: "basic-addon1"
    }, "@"),
    /*#__PURE__*/_createElementVNode("input", {
      type: "text",
      class: "form-control",
      placeholder: "Username",
      "aria-label": "Username",
      "aria-describedby": "basic-addon1"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "input-group input-group-solid mb-5" }, [
    /*#__PURE__*/_createElementVNode("input", {
      type: "text",
      class: "form-control",
      placeholder: "Recipient's username",
      "aria-label": "Recipient's username",
      "aria-describedby": "basic-addon2"
    }),
    /*#__PURE__*/_createElementVNode("span", {
      class: "input-group-text",
      id: "basic-addon2"
    }, "@example.com")
  ]),
  /*#__PURE__*/_createElementVNode("label", {
    for: "basic-url",
    class: "form-label"
  }, "Your vanity URL"),
  /*#__PURE__*/_createElementVNode("div", { class: "input-group input-group-solid mb-5" }, [
    /*#__PURE__*/_createElementVNode("span", {
      class: "input-group-text",
      id: "basic-addon3"
    }, "https://example.com/users/"),
    /*#__PURE__*/_createElementVNode("input", {
      type: "text",
      class: "form-control",
      id: "basic-url",
      "aria-describedby": "basic-addon3"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "input-group input-group-solid mb-5" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, "$"),
    /*#__PURE__*/_createElementVNode("input", {
      type: "text",
      class: "form-control",
      "aria-label": "Amount (to the nearest dollar)"
    }),
    /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, ".00")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "input-group input-group-solid mb-5" }, [
    /*#__PURE__*/_createElementVNode("input", {
      type: "text",
      class: "form-control",
      placeholder: "Username",
      "aria-label": "Username"
    }),
    /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, "@"),
    /*#__PURE__*/_createElementVNode("input", {
      type: "text",
      class: "form-control",
      placeholder: "Server",
      "aria-label": "Server"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "input-group input-group-solid" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, "With textarea"),
    /*#__PURE__*/_createElementVNode("textarea", {
      class: "form-control",
      "aria-label": "With textarea"
    })
  ])
], -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", {
  class: "tab-pane fade",
  id: "kt_timeline_widget_2_tab_4",
  role: "tabpanel"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group input-group-solid mb-5" }, [
    /*#__PURE__*/_createElementVNode("span", {
      class: "input-group-text",
      id: "basic-addon1"
    }, "@"),
    /*#__PURE__*/_createElementVNode("input", {
      type: "text",
      class: "form-control",
      placeholder: "Username",
      "aria-label": "Username",
      "aria-describedby": "basic-addon1"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "input-group input-group-solid mb-5" }, [
    /*#__PURE__*/_createElementVNode("input", {
      type: "text",
      class: "form-control",
      placeholder: "Recipient's username",
      "aria-label": "Recipient's username",
      "aria-describedby": "basic-addon2"
    }),
    /*#__PURE__*/_createElementVNode("span", {
      class: "input-group-text",
      id: "basic-addon2"
    }, "@example.com")
  ]),
  /*#__PURE__*/_createElementVNode("label", {
    for: "basic-url",
    class: "form-label"
  }, "Your vanity URL"),
  /*#__PURE__*/_createElementVNode("div", { class: "input-group input-group-solid mb-5" }, [
    /*#__PURE__*/_createElementVNode("span", {
      class: "input-group-text",
      id: "basic-addon3"
    }, "https://example.com/users/"),
    /*#__PURE__*/_createElementVNode("input", {
      type: "text",
      class: "form-control",
      id: "basic-url",
      "aria-describedby": "basic-addon3"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "input-group input-group-solid mb-5" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, "$"),
    /*#__PURE__*/_createElementVNode("input", {
      type: "text",
      class: "form-control",
      "aria-label": "Amount (to the nearest dollar)"
    }),
    /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, ".00")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "input-group input-group-solid mb-5" }, [
    /*#__PURE__*/_createElementVNode("input", {
      type: "text",
      class: "form-control",
      placeholder: "Username",
      "aria-label": "Username"
    }),
    /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, "@"),
    /*#__PURE__*/_createElementVNode("input", {
      type: "text",
      class: "form-control",
      placeholder: "Server",
      "aria-label": "Server"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "input-group input-group-solid" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, "With textarea"),
    /*#__PURE__*/_createElementVNode("textarea", {
      class: "form-control",
      "aria-label": "With textarea"
    })
  ])
], -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", {
  class: "tab-pane fade",
  id: "kt_timeline_widget_2_tab_5",
  role: "tabpanel"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group input-group-solid mb-5" }, [
    /*#__PURE__*/_createElementVNode("span", {
      class: "input-group-text",
      id: "basic-addon1"
    }, "@"),
    /*#__PURE__*/_createElementVNode("input", {
      type: "text",
      class: "form-control",
      placeholder: "Username",
      "aria-label": "Username",
      "aria-describedby": "basic-addon1"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "input-group input-group-solid mb-5" }, [
    /*#__PURE__*/_createElementVNode("input", {
      type: "text",
      class: "form-control",
      placeholder: "Recipient's username",
      "aria-label": "Recipient's username",
      "aria-describedby": "basic-addon2"
    }),
    /*#__PURE__*/_createElementVNode("span", {
      class: "input-group-text",
      id: "basic-addon2"
    }, "@example.com")
  ]),
  /*#__PURE__*/_createElementVNode("label", {
    for: "basic-url",
    class: "form-label"
  }, "Your vanity URL"),
  /*#__PURE__*/_createElementVNode("div", { class: "input-group input-group-solid mb-5" }, [
    /*#__PURE__*/_createElementVNode("span", {
      class: "input-group-text",
      id: "basic-addon3"
    }, "https://example.com/users/"),
    /*#__PURE__*/_createElementVNode("input", {
      type: "text",
      class: "form-control",
      id: "basic-url",
      "aria-describedby": "basic-addon3"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "input-group input-group-solid mb-5" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, "$"),
    /*#__PURE__*/_createElementVNode("input", {
      type: "text",
      class: "form-control",
      "aria-label": "Amount (to the nearest dollar)"
    }),
    /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, ".00")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "input-group input-group-solid mb-5" }, [
    /*#__PURE__*/_createElementVNode("input", {
      type: "text",
      class: "form-control",
      placeholder: "Username",
      "aria-label": "Username"
    }),
    /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, "@"),
    /*#__PURE__*/_createElementVNode("input", {
      type: "text",
      class: "form-control",
      placeholder: "Server",
      "aria-label": "Server"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "input-group input-group-solid" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, "With textarea"),
    /*#__PURE__*/_createElementVNode("textarea", {
      class: "form-control",
      "aria-label": "With textarea"
    })
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_UploadApplicationFileModal = _resolveComponent("UploadApplicationFileModal")!
  const _component_PdfViewModal = _resolveComponent("PdfViewModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h3", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.getAppId), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("table", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.applicationFiles, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      (item.filestorage === '1')
                        ? (_openBlock(), _createElementBlock("td", _hoisted_12, _hoisted_14))
                        : _createCommentVNode("", true),
                      (item.filestorage === '0')
                        ? (_openBlock(), _createElementBlock("td", _hoisted_15, _hoisted_17))
                        : _createCommentVNode("", true),
                      _createElementVNode("td", _hoisted_18, _toDisplayString(item.fileid), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("a", _hoisted_19, _toDisplayString(item.filetitle), 1),
                        _createElementVNode("span", _hoisted_20, _toDisplayString(item.dateuploaded), 1)
                      ]),
                      (item.reviewed === '1')
                        ? (_openBlock(), _createElementBlock("td", _hoisted_21, _hoisted_24))
                        : _createCommentVNode("", true),
                      (item.reviewed === '2')
                        ? (_openBlock(), _createElementBlock("td", _hoisted_25, _hoisted_28))
                        : _createCommentVNode("", true),
                      (item.reviewed === '0')
                        ? (_openBlock(), _createElementBlock("td", _hoisted_29, _hoisted_32))
                        : _createCommentVNode("", true),
                      (item.filestorage === '0')
                        ? (_openBlock(), _createElementBlock("td", _hoisted_33, [
                            _createElementVNode("div", _hoisted_34, [
                              _createElementVNode("button", _hoisted_35, [
                                _createElementVNode("span", _hoisted_36, [
                                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr078.svg" })
                                ]),
                                _createTextVNode("Upload Doc: " + _toDisplayString(item.fileid), 1)
                              ])
                            ]),
                            _createVNode(_component_UploadApplicationFileModal, {
                              fileid: item.fileid,
                              onSubmit: _ctx.getApplicationFiles
                            }, null, 8, ["fileid", "onSubmit"])
                          ]))
                        : (_openBlock(), _createElementBlock("td", _hoisted_37, [
                            _createElementVNode("div", _hoisted_38, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-sm btn-icon btn-active-color-primary",
                                onClick: _withModifiers(($event: any) => (_ctx.onOpenPdfView(item.fileurl)), ["prevent"])
                              }, [
                                _createElementVNode("span", _hoisted_40, [
                                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/files/fil024.svg" })
                                ])
                              ], 8, _hoisted_39),
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-sm btn-icon btn-active-color-danger",
                                onClick: ($event: any) => (_ctx.onDeleteFile(item.fileid))
                              }, [
                                _createElementVNode("span", _hoisted_42, [
                                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/files/fil007.svg" })
                                ])
                              ], 8, _hoisted_41)
                            ])
                          ]))
                    ]))
                  }), 128))
                ])
              ])
            ])
          ]),
          _hoisted_43,
          _hoisted_44,
          _hoisted_45,
          _hoisted_46
        ])
      ]),
      _createVNode(_component_PdfViewModal, { url: _ctx.pdfUrl }, null, 8, ["url"])
    ])
  ], 64))
}